"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPACT_SHOW_VIDEO_LIST_VALUES = void 0;
var COMPACT_SHOW_VIDEO_LIST_VALUES;
(function (COMPACT_SHOW_VIDEO_LIST_VALUES) {
    COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["EXPAND_ON_CLICK"] = 1] = "EXPAND_ON_CLICK";
    COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["ALWAYS_SHOW"] = 2] = "ALWAYS_SHOW";
    COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["NEVER_SHOW"] = 3] = "NEVER_SHOW";
})(COMPACT_SHOW_VIDEO_LIST_VALUES = exports.COMPACT_SHOW_VIDEO_LIST_VALUES || (exports.COMPACT_SHOW_VIDEO_LIST_VALUES = {}));
//# sourceMappingURL=compact-show-video-list.js.map